/**
 * @enum {string}
 */
module.exports = {
    OPEN_AI: 'OPEN_AI',
    ANTHROPIC: 'ANTHROPIC'
};
